/**
 * Utilitaire pour fusionner les classes CSS avec clsx et tailwind-merge
 */

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Fusionne les classes CSS en gérant les conflits Tailwind
 * @param {...any} inputs - Classes CSS à fusionner
 * @returns {string} Classes CSS fusionnées
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export default cn;
